
import { AdminPeopleView } from './admin/AdminPeopleView'
import { TeacherPeopleView } from './teacher/TeacherPeopleView'

import { PersonaSwitcher } from '../../../components/PersonaSwitcher';

const People = () => <PersonaSwitcher
    adminView={<AdminPeopleView />}
    teacherView={<TeacherPeopleView />} />

export { People }
